<template>
  <InLifeDashboard
    :is-mobile="isMobile"
    :name="$auth.user.name"
    :display-delivered-card="Boolean(deliveredCarRego)"
    :car-delivered-img="carDeliveredImg"
    :car-delivered-rego="deliveredCarRego"
    :has-leases="hasLeases"
    :lease-without-data-img="leaseWithoutDataImg"
    :lease-groups="leaseGroups"
    :leases-loading="leasesLoading"
    :display-in-life="hasLeasesOrCompleteApplication || leasesLoading"
    @open:lease="openLease"
    @open:budget="openBudget"
  />
</template>

<script>
import { getAsset } from 'ecx.saigon.ui.common';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { date, Dialog } from 'quasar';
import reduceCollectionToGroups from '../../utils/reduce-collection-to-groups';
import BudgetWarningDialog from '../../components/molecule/budget-warning-dialog';

export default {
  name: 'InLifeDashboardWidget',
  data() {
    return {
      leaseGroups: [],
      carDeliveredImg: undefined,
      leaseWithoutDataImg: undefined,
      deliveredCarRego: undefined
    };
  },
  watch: {
    leasesLoading() {
      if (this.leasesLoading || !this.leases.length) {
        return;
      }

      const currentDate = new Date();
      let lastWeek = date.subtractFromDate(new Date(), { days: 7 });
      lastWeek = date.startOfDate(lastWeek, 'day');

      for (let i = 0; i < this.leases.length; i++) {
        const lease = this.leases[i];
        if (!lease.leaseStartDate) {
          continue;
        }
        const isValidDate = date.isBetweenDates(
          new Date(lease.leaseStartDate),
          lastWeek,
          currentDate,
          { inclusiveFrom: true, inclusiveTo: true }
        );
        if (isValidDate && !this.deliveryMessageShown[lease.id]) {
          this.deliveryMessageShownTo(lease.id);
          this.deliveredCarRego = lease.vehicleRego;
          return;
        }
      }
    },
    isMobile() {
      this.setLeaseGroups();
    },
    leases: {
      immediate: true,
      handler() {
        this.setLeaseGroups();
      }
    },
    getActiveLeasesWithoutData: {
      immediate: true,
      handler() {
        this.setLeaseGroups();
      }
    }
  },
  computed: {
    ...mapState({
      hasLeases: (state) => state.lease.hasLeases,
      leases: (state) => state.lease.leases,
      leasesLoading: (state) => state.lease.leasesLoading,
      deliveryMessageShown: (state) => state.lease.deliveryMessageShown
    }),
    ...mapGetters(['hasLeasesOrCompleteApplication']),
    ...mapGetters('settlement', ['getActiveLeasesWithoutData']),
    isMobile() {
      return this.$q.screen.xs;
    }
  },
  methods: {
    ...mapMutations('lease', ['setSelectedLease', 'deliveryMessageShownTo']),
    openLease(lease) {
      this.setSelectedLease(lease);
      this.$router.push({
        name: this.$RouteNames.lease,
        params: {
          leaseId: lease.id
        }
      });
    },
    openBudget(lease) {
      Dialog.create({
        component: BudgetWarningDialog,
        label: 'Important information',
        okText: 'Ok',
        maxWidth: '835px',
        actionsGrow: true,
        displayHideAction: false,
        justifyCenter: true,
        labelIcon: 'eva-alert-triangle',
        labelIconColor: 'orange',
      }).onOk(() => {
        this.setSelectedLease(lease);
        this.$router.push({ name: this.$RouteNames.budgets });
      });
    },
    setLeaseGroups() {
      const slidesPerGroup = this.isMobile ? 1 : 2;
      this.leaseGroups = reduceCollectionToGroups(
        [...this.getActiveLeasesWithoutData, ...this.leases],
        [],
        slidesPerGroup
      );
    }
  },
  async beforeMount() {
    this.carDeliveredImg = await getAsset(
      this.$Constants.CAR_DELIVERED_IMG_PATH
    );
    this.leaseWithoutDataImg = await getAsset(
      this.$Constants.LEASE_WITHOUT_IMG_PATH
    );
  },
  components: {
    InLifeDashboard: () => import('../../components/organism/in-life-dashboard')
  }
};
</script>
